const GenericErrorIllustration = () => {
  return (
    <svg width="372" height="182" viewBox="0 0 372 182" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M151.132 38.1691L185.104 37.5774C185.356 37.5774 185.608 37.6151 185.86 37.7033L151.887 38.295C151.635 38.2006 151.377 38.1628 151.132 38.1691Z"
        fill="#C4D1EC"
        stroke="#0E1A33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M151.887 38.3014L185.86 37.7097L189.391 38.9875L155.418 39.5793L151.887 38.3014Z"
        fill="#C4D1EC"
        stroke="#0E1A33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M190.14 39.1198L156.167 39.7115C155.916 39.7115 155.664 39.6737 155.412 39.5856L189.385 38.9939C189.636 39.0883 189.888 39.1261 190.14 39.1198Z"
        fill="#C4D1EC"
        stroke="#0E1A33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M161.978 30.779L195.95 30.1873C196.202 30.1873 196.454 30.225 196.706 30.3132L162.733 30.9049C162.481 30.8104 162.223 30.7727 161.978 30.779Z"
        fill="#C4D1EC"
        stroke="#0E1A33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M162.733 30.9113L196.699 30.3196L200.231 31.5974L166.258 32.1891L162.733 30.9113Z"
        fill="#C4D1EC"
        stroke="#0E1A33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M200.986 31.7297L167.013 32.3214C166.762 32.3214 166.51 32.2836 166.258 32.1955L200.231 31.6038C200.482 31.6982 200.734 31.736 200.986 31.7297Z"
        fill="#C4D1EC"
        stroke="#0E1A33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M172.817 23.3891L206.79 22.7974C207.041 22.7974 207.293 22.8351 207.545 22.9232L173.572 23.515C173.32 23.4205 173.062 23.3828 172.817 23.3891Z"
        fill="#C4D1EC"
        stroke="#0E1A33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M207.834 149.403C206.745 149.422 205.751 150.31 205.436 151.682L204.429 156.057C204.114 157.423 203.12 158.317 202.031 158.336L236.003 157.744C237.092 157.725 238.087 156.831 238.402 155.465L239.409 151.09C239.724 149.724 240.718 148.831 241.807 148.812L207.834 149.403Z"
        fill="#0E1A33"
        stroke="#0E1A33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M218.674 142.014C217.585 142.033 216.59 142.927 216.276 144.293L215.269 148.661C214.954 150.027 213.959 150.921 212.87 150.94L246.843 150.348C247.932 150.329 248.926 149.435 249.241 148.069L250.248 143.701C250.563 142.335 251.558 141.441 252.647 141.422L218.674 142.014Z"
        fill="#0E1A33"
        stroke="#0E1A33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M186.527 40.3601L220.5 39.7683C224.472 39.6991 228.519 40.36 232.535 41.8141C254.132 49.6637 266.646 77.7129 260.49 104.472C255.479 126.252 239.648 140.465 222.287 140.767L188.315 141.359C205.676 141.057 221.513 126.85 226.517 105.064C232.674 78.3046 220.154 50.2491 198.563 42.4058C194.547 40.9455 190.493 40.2908 186.527 40.3601Z"
        fill="#C4D1EC"
        stroke="#0E1A33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M173.572 23.5211L207.545 22.9294L261.692 42.6068L227.726 43.1985L173.572 23.5211Z"
        fill="#C4D1EC"
        stroke="#0E1A33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M267.729 56.1277L264.204 54.8436C262.85 54.3526 262.064 52.5838 262.448 50.9094L263.455 46.5409C263.839 44.8602 263.058 43.0977 261.698 42.6067L227.726 43.1984C229.086 43.6894 229.866 45.4519 229.482 47.1326L228.475 51.5011C228.091 53.1755 228.878 54.9444 230.231 55.4353L233.756 56.7194L267.729 56.1277Z"
        fill="#C4D1EC"
        stroke="#0E1A33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M273.759 69.6483L270.234 68.3641C268.874 67.8732 268.094 66.1043 268.478 64.4299L269.485 60.0614C269.869 58.3807 269.088 56.6182 267.729 56.1272L233.756 56.7189C235.116 57.2099 235.896 58.9724 235.512 60.6531L234.505 65.0216C234.121 66.696 234.902 68.4649 236.261 68.9558L239.786 70.24L273.759 69.6483Z"
        fill="#C4D1EC"
        stroke="#0E1A33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M170.419 25.6679C170.803 23.9872 172.219 23.0241 173.572 23.5151L227.72 43.1924C229.079 43.6834 229.86 45.4459 229.476 47.1266L228.469 51.4951C228.085 53.1695 228.872 54.9384 230.225 55.4293L233.75 56.7135C235.11 57.2045 235.89 58.967 235.506 60.6477L234.499 65.0162C234.115 66.6906 234.896 68.4594 236.255 68.9504L239.78 70.2345C241.14 70.7255 241.92 72.488 241.536 74.1687L226.102 141.27C225.718 142.951 224.301 143.914 222.948 143.423L219.423 142.139C218.063 141.648 216.653 142.605 216.269 144.292L215.262 148.66C214.878 150.341 213.462 151.304 212.109 150.813L208.584 149.529C207.23 149.038 205.814 149.995 205.43 151.682L204.423 156.05C204.039 157.731 202.623 158.694 201.269 158.203L147.122 138.526C145.762 138.035 144.982 136.272 145.366 134.592L146.373 130.223C146.757 128.543 145.976 126.78 144.617 126.289L141.092 125.005C139.732 124.514 138.951 122.751 139.335 121.071L140.342 116.702C140.726 115.021 139.946 113.259 138.586 112.768L135.061 111.484C133.702 110.993 132.921 109.23 133.305 107.55L148.74 40.4479C149.124 38.7672 150.534 37.8041 151.893 38.2951L155.418 39.5792C156.778 40.0702 158.188 39.1071 158.572 37.4264L159.579 33.0579C159.963 31.3772 161.38 30.4141 162.733 30.9051L166.258 32.1892C167.618 32.6802 169.028 31.7171 169.412 30.0364L170.419 25.6679Z"
        fill="#F8F9FF"
        stroke="#0E1A33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M275.515 73.5829C275.899 71.9022 275.119 70.1397 273.759 69.6487L239.786 70.2404C241.146 70.7314 241.927 72.4939 241.543 74.1746L226.108 141.276C225.793 142.642 224.799 143.536 223.71 143.555L257.682 142.963C258.771 142.944 259.766 142.051 260.081 140.685L275.515 73.5829Z"
        fill="#C4D1EC"
        stroke="#0E1A33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M141.381 153.061C140.834 153.067 140.28 153.294 139.82 153.747L136.931 156.573C136.465 157.026 135.917 157.253 135.364 157.259L168.581 156.693C169.135 156.686 169.682 156.46 170.148 156.007L173.038 153.18C173.497 152.727 174.051 152.507 174.599 152.494L141.381 153.061Z"
        fill="#0E1A33"
        stroke="#0E1A33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M153.864 154.828C153.316 154.835 152.762 155.061 152.303 155.514L149.414 158.347C148.954 158.8 148.4 159.021 147.853 159.033L181.07 158.467C181.617 158.454 182.171 158.234 182.631 157.78L185.52 154.948C185.98 154.495 186.534 154.274 187.081 154.262L153.864 154.828Z"
        fill="#0E1A33"
        stroke="#0E1A33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M184.267 26.2654L181.938 22.6963C181.416 21.8968 180.642 21.4877 179.867 21.5003L146.65 22.0668C147.424 22.0542 148.199 22.4634 148.721 23.2628L151.05 26.8319C151.573 27.6313 152.347 28.0468 153.121 28.0342L186.338 27.4677C185.564 27.4803 184.796 27.0711 184.267 26.2654Z"
        fill="#C4D1EC"
        stroke="#0E1A33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M196.744 28.0345L194.415 24.4654C193.892 23.666 193.118 23.2505 192.35 23.2694L159.133 23.8359C159.907 23.8233 160.675 24.2325 161.197 25.0319L163.526 28.601C164.049 29.4005 164.823 29.8159 165.591 29.8033L198.808 29.2368C198.034 29.2494 197.266 28.8402 196.744 28.0345Z"
        fill="#C4D1EC"
        stroke="#0E1A33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M206.286 116.67L161.889 160.116C161.43 160.569 160.876 160.79 160.328 160.802L193.546 160.236C194.093 160.23 194.647 160.003 195.107 159.55L239.503 116.104L206.286 116.67Z"
        fill="#0E1A33"
        stroke="#0E1A33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M206.097 88.885L208.987 86.0587L242.204 85.4922L239.314 88.3185C238.2 89.4075 238.03 91.4029 238.918 92.7752L205.701 93.3417C204.807 91.9758 204.983 89.974 206.097 88.885Z"
        fill="#0E1A33"
        stroke="#0E1A33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M239.9 111.646L237.571 108.077L204.354 108.644L206.683 112.213C207.577 113.585 207.4 115.58 206.286 116.669L239.503 116.103C240.611 115.02 240.794 113.025 239.9 111.646Z"
        fill="#C4D1EC"
        stroke="#0E1A33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M240.851 100.795L207.633 101.361L204.744 104.188C203.63 105.277 203.46 107.272 204.348 108.644L237.565 108.078C236.671 106.712 236.847 104.71 237.961 103.621L240.851 100.795Z"
        fill="#0E1A33"
        stroke="#0E1A33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M241.253 96.3389L238.924 92.7698L205.707 93.3363L208.036 96.9054C208.93 98.2777 208.754 100.273 207.64 101.362L240.857 100.796C241.971 99.7066 242.147 97.7111 241.253 96.3389Z"
        fill="#C4D1EC"
        stroke="#0E1A33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M242.6 81.036L206.897 26.2404C206.374 25.4347 205.6 25.0255 204.826 25.0381L171.609 25.6046C172.383 25.5921 173.151 26.0012 173.679 26.8069L209.383 81.6025C210.277 82.9747 210.101 84.9702 208.987 86.0592L242.204 85.4927C243.318 84.4037 243.494 82.4145 242.6 81.0423V81.036Z"
        fill="#C4D1EC"
        stroke="#0E1A33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M170.041 26.2904C171.155 25.2014 172.779 25.4344 173.673 26.8066L209.377 81.6022C210.271 82.9744 210.095 84.9698 208.98 86.0588L206.091 88.8852C204.977 89.9741 204.807 91.9696 205.695 93.3418L208.024 96.9109C208.917 98.2832 208.741 100.279 207.627 101.368L204.738 104.194C203.624 105.283 203.454 107.278 204.341 108.651L206.67 112.22C207.564 113.592 207.388 115.587 206.274 116.676L161.877 160.123C160.769 161.205 159.139 160.979 158.245 159.606L155.916 156.037C155.022 154.671 153.398 154.432 152.284 155.521L149.395 158.354C148.287 159.436 146.656 159.21 145.762 157.838L143.433 154.268C142.54 152.903 140.916 152.663 139.801 153.752L136.912 156.579C135.798 157.668 134.174 157.441 133.274 156.069L97.5701 101.273C96.6763 99.9009 96.8525 97.9055 97.9667 96.8165L100.856 93.9902C101.97 92.9012 102.146 90.9121 101.253 89.5335L98.9234 85.9644C98.0296 84.5922 98.2058 82.5967 99.32 81.5077L102.209 78.6751C103.323 77.5861 103.5 75.597 102.606 74.2185L100.277 70.6493C99.3829 69.2834 99.5592 67.2817 100.673 66.1927L145.07 22.7465C146.178 21.6638 147.808 21.8904 148.702 23.2627L151.031 26.8318C151.925 28.204 153.549 28.437 154.663 27.348L157.552 24.5216C158.667 23.4326 160.291 23.6592 161.191 25.0315L163.52 28.6006C164.414 29.9729 166.038 30.2058 167.152 29.1168L170.041 26.2904Z"
        fill="#F8F9FF"
        stroke="#0E1A33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g clipPath="url(#clip0_4109_2504)">
        <path
          d="M137.519 71.5335L141.828 117.354C141.933 118.322 142.246 119.23 142.739 119.987C143.231 120.743 143.884 121.323 144.633 121.667C145.383 122.012 146.202 122.109 147.01 121.95C147.818 121.791 148.586 121.381 149.239 120.76L180.615 90.2546C181.257 89.6175 181.756 88.7956 182.063 87.8707C182.37 86.9458 182.474 85.9502 182.365 84.9829C182.256 84.0156 181.938 83.1103 181.443 82.3571C180.947 81.604 180.291 81.0291 179.54 80.6898L143.853 65.3748C143.107 65.0605 142.299 64.9872 141.505 65.162C140.712 65.3369 139.961 65.7539 139.324 66.3729C138.688 66.9919 138.187 67.792 137.871 68.6959C137.554 69.5999 137.433 70.5772 137.519 71.5335Z"
          stroke="#FF4240"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M147.955 79.5657L153.613 88.2129"
          stroke="#FF4240"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M159.269 96.8591L159.288 96.8411"
          stroke="#FF4240"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4109_2504">
          <rect
            width="62"
            height="62"
            fill="white"
            transform="matrix(0.716988 -0.697085 0.54747 0.836825 113 81.7192)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default GenericErrorIllustration;
